// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__ljlpj","relative":"SpinnerButton_relative__ccVwV","hideText":"SpinnerButton_hideText__E6WY8"};